import React from 'react';
import classNames from 'classnames';
import { Icon } from 'Components';
import Button from '../Button';
import { ReportActionButtonProps } from './ReportActions.types';
import { SAVE_REPORT_LABEL } from './ReportActions.constants';
import styles from './ReportActions.module.scss';

const SaveReportButton: React.FC<ReportActionButtonProps> = ({
	onClick,
	disabled,
	className,
	label = SAVE_REPORT_LABEL
}) => (
	<Button
		variant="border"
		size="small"
		className={classNames(styles.button, className)}
		onClick={onClick}
		disabled={disabled}
	>
		<Icon type="savedMenuIcon" role="img" className={styles.icon} />
		{label}
	</Button>
);

export default SaveReportButton;
